/* SchemaForm helper for schema rendering */
import React, { useState } from "react";
import lodash from "lodash";
import l from "components/util/l"
import { getShowInput } from "components/util/schema_form/util/schema_form";
import ItemRender from "./SchemaForm.sub.ItemRender.view";
import DependenciesObserver from "./SchemaForm.sub.DependenciesObserver.view";


const SchemaRender = ({
  schema = [],
  parentId,
  parentKey = "",
  appId,
  actionId,
  flowId,
  nodeId,
  executionId,
  values,
  sectionIdx,
  showSideSteps,
  isDeveloper,
  isReadOnly,
  isCommentEnabled,
  setFieldValue,
  setValues,
}) => {

  const [showCollapse, setShowCollapse] = useState(null)
  const hiddenId = "schema-form-hidden-" + parentKey.replaceAll("[", "").replaceAll("]", "").replaceAll(".", "-")
  const visibleItems = schema.filter(input => !input.hidden && getShowInput(parentKey, input?.show_if ?? [], values));
  const hiddenItems = schema.filter(input => input.hidden && getShowInput(parentKey, input?.show_if ?? [], values));

  // Determine if we need to show the collapse section by default
  hiddenItems.forEach(input => {
    const schemaKey = parentKey == "" ? input.name : `${parentKey}.${input.name}`
    const schemaValue = lodash.get(values, schemaKey)
    if (schemaValue != undefined &&
      schemaValue != "" &&
      schemaValue != input.default &&
      showCollapse == null)
      setShowCollapse(true);
  })

  const renderItems = (itemList) =>
    itemList.map((input, idx) =>
      <ItemRender
        key={input.name}
        input={input}
        appId={appId}
        actionId={actionId}
        flowId={flowId}
        nodeId={nodeId}
        executionId={executionId}
        parentId={parentId}
        sectionIdx={sectionIdx}
        nextInput={idx < itemList.length - 1 ? itemList[idx + 1] : null}
        prevInput={idx > 0 ? itemList[idx - 1] : null}
        values={values}
        parentKey={parentKey}
        showSideSteps={showSideSteps}
        isDeveloper={isDeveloper}
        isReadOnly={isReadOnly}
        isCommentEnabled={isCommentEnabled}
        setFieldValue={setFieldValue}
        setValues={setValues}
      />)

  return <div>
    <DependenciesObserver
      schema={schema}
      parentKey={parentKey}
      values={values}
      setFieldValue={setFieldValue}
    />

    <ul className={(showSideSteps || parentKey != "" ?
      "step step-form step-eicon-xs mb-0 " : "no-step-form ") + 
      (parentKey != "" ? "sub " : "pr-4 ")}>
      {/* Render visible items */}
      {renderItems(visibleItems)}
    </ul>

    {hiddenItems.length > 0 &&
      <div class="mb-2 mt-1">
        {/* Collapse toggle link */}
        <a class=" btn btn-sm btn-lighter py-2 px-2 mb-3 mt-n4 text-left ml-7"
          data-toggle="collapse"
          style={{ border: "none", color: "#959595" }}
          href={"#" + hiddenId}
          role="button"
          aria-expanded="false"
          aria-controls="schema-form-hidden">
          {l("Más opciones%SA251")}
          <i class="ml-1 fas fa-chevron-down"
            style={{ color: "#aaa" }} ></i>
        </a>

        <div id={hiddenId}
          class={"collapse " + (showCollapse ? "show" : "")} >
          <ul className={"step step-form step-eicon-xs mb-0 ml-5 " + 
            (parentKey != "" ? "sub " : "pr-4 ")}>
            {/* Render hidden items */}
            {renderItems(hiddenItems)}
          </ul>
        </div>
      </div>}

  </div>
}

export default SchemaRender;